/**
 * Created by Ning Jiang on 2021-05-27.
 */

import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData, ReelState} from "../../../core/reel/ReelState";
import {ElGordosRevengeSound} from "../../sound/ElGordosRevengeSound";
import {ElGordosRevenge} from "../../ElGordosRevenge";

export class ReelStopSoundController extends ReelStopPresentationController {

    private _spinStates:boolean[];

    constructor() {
        super('ReelStopSoundController');
    }

    public async start():Promise<any> {
        this._spinStates = ElGordosRevenge.reels.map(reel => reel.reelState === ReelState.SPIN);
        await super.start();
    }

    protected onReelBounce(data:IReelStateEventData):Promise<any> {
        ElGordosRevengeSound.playRandomReelLandingSound(data.reelId);
        this._spinStates[data.reelId] = false;
        if(this._spinStates.every(s => !s)) {
            ElGordosRevengeSound.soundPlayer.stopTrack(ElGordosRevengeSound.REELS_SPINNING);
        }

        return super.onReelBounce(data);
    }
}